var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Text } from '../Text/Text';
import { LottieAnimation } from '../LottieAnimation';
import { AlertWrapper, AlertIcon, StyledIcon, AlertAction, AlertContent, } from './Alert.styles';
// @ts-ignore
import loadingLottie from '../../../../assets/animations/lottie-loading.json';
const getIconForAlertType = (type) => {
    switch (type) {
        case 'loading':
            return React.createElement(LottieAnimation, { data: loadingLottie, loop: true });
        default:
            return React.createElement(StyledIcon, { sprite: `icon-${type}-lite` });
    }
};
export const Alert = (_a) => {
    var { type = 'info', title, message, action, withoutIcon = false, withoutBorder } = _a, rest = __rest(_a, ["type", "title", "message", "action", "withoutIcon", "withoutBorder"]);
    return (React.createElement(AlertWrapper, Object.assign({ type: type, withoutBorder: withoutBorder }, rest),
        !withoutIcon && React.createElement(AlertIcon, null, getIconForAlertType(type)),
        React.createElement(AlertContent, null,
            title && (React.createElement(Text, { el: "div", styleName: "title8" }, title)),
            React.createElement(Text, { styleName: "bodyRegular", el: "div" }, message)),
        action && React.createElement(AlertAction, null, action)));
};
//# sourceMappingURL=Alert.js.map